// extracted by mini-css-extract-plugin
export default {"root":"i1dWe","smallMobile":"BzrHX","mobile":"JiAow","loginInfo":"Knxxu","description":"E9Za1"};